export default "__VITE_ASSET__f9567c0e__"